import { REGIONEAEREOPARTENZA} from './regioneAereoPartenzaTypes'

const initialState = {
    regioneAereoPartenza: ""
}

const regioneAereoPartenzaReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case REGIONEAEREOPARTENZA:
            
            return {
                regioneAereoPartenza: action.load
            }
    
        default:
          return state
    }

}


export default regioneAereoPartenzaReducer;